import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { logActivity } from "../services/user-activity";

export default function LogUserActivity(): null {
  const { pathname } = useLocation();

  useEffect(() => {
    logActivity();
  }, [pathname]);

  return null;
}
